import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(AvInput).attrs({ type: 'textarea' })`
  && {
    height: 100px;
    min-height: 100px;
  }
`;
